import axios from 'axios';
import { API_BASE_URL } from '../../utils/constants';


const api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 30000,
});

// Request interceptor for logging
api.interceptors.request.use(
    (config) => {
        console.log('API Request:', config.method?.toUpperCase(), config.url);
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for error handling
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.error('API Error:', error.response?.data || error.message);
        return Promise.reject(error);
    }
);

export const explorerApi = {
    // Get withdrawals with pagination and search
    getWithdrawals: (params = {}) => {
        return api.get('/explorer/withdrawals', { params });
    },

    // Get deposits with pagination and search
    getDeposits: (params = {}) => {
        return api.get('/explorer/deposits', { params });
    },

    // Get blockchain statistics
    getStats: () => {
        return api.get('/explorer/stats');
    },

    // Get transaction by ID
    getTransactionById: (txId) => {
        return api.get(`/explorer/transaction/${ txId }`);
    },

    // Get user transactions
    getUserTransactions: (userId) => {
        return api.get(`/explorer/user/${ userId }`);
    },

    // Get user details with pagination support
    getUserDetails: (userId, page = 1, limit = 20) => {
        return api.get(`/explorer/user/${ userId }`, {
            params: { page, limit }
        }).then(response => response.data);
    },

    // Get address transactions
    getAddressTransactions: (address) => {
        return api.get(`/explorer/address/${ address }`);
    },

    // Get general connections (all or by txId)
    getConnections: (params = {}) => {
        return api.get('/explorer/connections', { params });
    },

    // Get node-specific connections for lazy loading
    getNodeConnections: (nodeType, nodeValue) => {
        return api.get('/explorer/node-connections', {
            params: { nodeType, nodeValue }
        }).then(response => response.data);
    },

    // Get initial transaction connection data
    getTransactionConnections: (txId) => {
        return api.get(`/explorer/connections/${ txId }`);
    },

    // Explore connections for a specific node (user or address)
    exploreNode: (type, id) => {
        return api.get(`/explorer/explore-node/${ type }/${ id }`);
    },

    // Get latest transactions across the network
    getLatestTransactions: (params = {}) => {
        return api.get('/explorer/latest-transactions', { params });
    },

    // Get top users by volume or transaction count
    getTopUsers: (params = {}) => {
        return api.get('/explorer/top-users', { params });
    },

    // Get top addresses by volume or transaction count
    getTopAddresses: (params = {}) => {
        return api.get('/explorer/top-addresses', { params });
    },

    // Get analytics and charts data
    getAnalytics: (params = {}) => {
        return api.get('/explorer/analytics', { params });
    },

    // Universal search
    search: (query) => {
        return api.get('/explorer/search', { params: { q: query } });
    },
};

export default api;
